"use client";

import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n'; 
import TextRevealDemo from '../page/TextReveal';
import About from '../page/About';
import Card from '../page/Card';
import Work from '../page/Work';
import Benefits from '../page/Benefits';
import { Templates } from '../page/Templates';
import UseCase from '../page/UseCase';
import Hero from '../page/Hero';
import Header from '../page/Header';
import Footer from '../main_page/footer';
import Pricingcard from '../page/PriceCard';

const Home: React.FC = () => {
    return (
        <I18nextProvider i18n={i18n}>
            <Suspense fallback={
  <div className="flex items-center justify-center h-screen bg-black text-white">
    <div className="text-center space-y-4">
      <div className="text-xl font-semibold animate-pulse">SPOTCARD IS LOADING...</div>
      <div className="w-12 h-12 border-4 border-t-transparent border-white rounded-full animate-spin mx-auto"></div>
    </div>
  </div>
}>
                <Header />
                <div className='bg-black-bg bg-fixed bg-cover bg-center text-white '>
                    <Hero />
                    <TextRevealDemo />
                    <About />
                    <Work />
                    <Card />
                    <Templates />
                    <UseCase />
                    <Pricingcard />
                    <Benefits theme='light'/>
                </div>
                <Footer />
            </Suspense>
        </I18nextProvider>
    );
}

export default Home;